import { useListContext } from "ra-core";
import { Fragment } from "react";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";

import { Note } from "./Note";
import { NoteCreate } from "./NoteCreate";
import { InfinitePagination } from "../misc/InfinitePagination";

export const NotesIterator = ({
  reference,
  showStatus,
  previewCount,
  onShowAll,
}: {
  reference: "contacts" | "deals";
  showStatus?: boolean;
  /** If set, only show this many notes and display a "View all" button */
  previewCount?: number;
  onShowAll?: () => void;
}) => {
  const { isPending, error, data = [], total } = useListContext();

  if (isPending || error) return null;

  const visibleData =
    previewCount != null ? data.slice(0, previewCount) : data;
  const hasMore =
    previewCount != null && total != null && total > previewCount;

  return (
    <div className="mt-4">
      <NoteCreate reference={reference} showStatus={showStatus} />
      {data.length > 0 && (
        <div className="mt-4 space-y-4">
          {visibleData.map((note, index) => (
            <Fragment key={note.id}>
              <Note
                note={note}
                isLast={index === visibleData.length - 1}
                showStatus={showStatus}
              />
              {index < visibleData.length - 1 && <Separator />}
            </Fragment>
          ))}
        </div>
      )}

      {hasMore && (
        <>
          <Separator className="mt-4" />
          <Button
            variant="ghost"
            size="sm"
            className="mt-2 w-full text-muted-foreground hover:text-foreground gap-1"
            onClick={onShowAll}
          >
            <ChevronDown className="w-4 h-4" />
            查看所有笔记
          </Button>
        </>
      )}

      {previewCount == null && <InfinitePagination />}
    </div>
  );
};
